import React from 'react';
import './ForecastCoverage.css';

// Import the icon images
import icon1 from '../../assets/images/commodity-icon-1.png';
import icon2 from '../../assets/images/commodity-icon-2.png';
import icon3 from '../../assets/images/commodity-icon-3.png';
import icon4 from '../../assets/images/commodity-icon-4.png';
import icon5 from '../../assets/images/commodity-icon-5.png';
import icon6 from '../../assets/images/commodity-icon-6.png';
import icon7 from '../../assets/images/commodity-icon-7.png';
import icon8 from '../../assets/images/commodity-icon-8.png';

// Data for the commodities, customized for your project
const commodities = [
  { name: 'Wheat', image: icon1 },
  { name: 'Rice', image: icon2 },
  { name: 'Soybean', image: icon3 },
  { name: 'Maize (Corn)', image: icon4 },
  { name: 'Cotton', image: icon5 },
  { name: 'Sugarcane', image: icon6 },
  { name: 'Pulses', image: icon7 },
  { name: 'Spices', image: icon8 },
];

const ForecastCoverage = () => {
  return (
    <section className="forecast-coverage-section">
      <div className="forecast-coverage-container">
        {/* Left Column: Text Content */}
        <div className="coverage-text-col">
          <h2>Multi commodity forecast coverage</h2>
          <p>
            Multi commodity forecast coverage Get forecast visibility across the full value chain, from raw materials to finished goods. CRISHI's models span multiple product categories, ensuring comprehensive market understanding.
          </p>
        </div>

        {/* Right Column: Icon Grid */}
        <div className="coverage-grid-col">
          <h4>Crop Commodities Covered</h4>
          <div className="commodities-grid">
            {commodities.map((item, index) => (
              <div key={index} className="commodity-item">
                <img src={item.image} alt={item.name} />
                <span>{item.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ForecastCoverage;